import { call, put, takeEvery } from 'redux-saga/effects';
import { getLeadOMConfig } from '../../requests/get_leadom_config_request';
import { getLeadOMConfigRequestSuccess, getLeadOMConfigRequestFailure } from '../actions/get_leadomatic_config.actions';
import { GET_LEADOM_CONFIG_REQUEST } from '../constants/leadom_config.constants';

function* getLeadOMRequest() {
    const { result, options } = yield call(getLeadOMConfig);
    result
        ? yield put(getLeadOMConfigRequestSuccess(options))
        : yield put(getLeadOMConfigRequestFailure('Something gone wrong!'));
}

export default function* getLeadOMSaga() {
    yield takeEvery(GET_LEADOM_CONFIG_REQUEST, getLeadOMRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/redux/sagas/get_leadomatic_config.saga.js